import AXIOS from "./axios";

export class PatientPayments {
  // Com `page`, o back filtra pela aba (`status`), devolve só a página e o
  // total no header Total-Count.
  static fetch(params = {}) {
    return AXIOS.get("appointments/payments", { params });
  }
}
